



























import { Component, Vue } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import repository from '@/modules/machinery/services/machineryEventTypesRepository';
import cPopup from '@/components/default/Popup.vue';
import cCard from '@/components/default/Card.vue';
import cDatagrid from '@/components/default/Datagrid.vue';

import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';

@Component({
  components: {
    cCard,
    cDatagrid,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
  },
})
export default class MachineryProfilesPage extends Vue {
  private items: any[] = [];
  private loading: boolean = false;
  private saving: boolean = false;

  private mounted() {
    this.loadData();
  }

  private async loadData() {
    try {
      this.loading = true;
      this.items = (await repository.getAll()).data;
    } catch (err) {
      notificationService.failedToLoad();
    } finally {
      this.loading = false;
    }
  }

  private addRow() {
    this.GridInstance.addRow();
  }

  private insertRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        self.saving = true;
        await repository.create(e.data);
        notificationService.saved();
        resolve(false);
      } catch (err) {
        notificationService.failedToSave();
      } finally {
        self.saving = false;
      }
      resolve(true);
    });
  }

  private updateRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        self.saving = true;
        const oldData = e.oldData;
        Object.assign(oldData, e.newData);
        await repository.update(oldData);
        notificationService.saved();
        resolve(false);
      } catch (err) {
        notificationService.failedToSave();
      } finally {
        self.saving = false;
      }
      resolve(true);
    });
  }

  private deleteRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        self.saving = true;
        await repository.delete(e.data.id);
        notificationService.saved();
        resolve(false);
      } catch {
        notificationService.failedToSave();
      } finally {
        self.saving = false;
      }
      resolve(true);
    });
  }

  get GridInstance() {
    return ((this.$refs.grid as Vue).$refs.machineryEventTypesTable as any).instance;
  }

  get columns() {
    return [
      {
        dataField: 'name',
        caption: this.$t('objects.MachineryEventTypes.fields.Name'),
      },
      {
        dataField: 'icon',
        caption: this.$t('objects.MachineryEventTypes.fields.Icon'),
        cellTemplate: (cellElement: any, cellInfo: any) => {
          return $(cellElement).append(`<i class='fas ${cellInfo.data.icon}'></i> ${cellInfo.data.icon}`);
        },
      },
      {
        type: 'buttons',
        buttons: ['edit', 'delete'],
      },
    ];
  }
}
